<template>
  <div id="news">
    <div v-for="n in news" :key="n.id" class="group-notif">
      <div class="date">
        <p>{{ n.created.day }} {{ n.created.month }} {{ n.created.year }}</p>
      </div>
      <div class="contenu">
        <p class="libelle">{{ n.title }}</p>
        <p class="texte" v-html="n.text"></p>
      </div>
    </div>
  </div>
  <!-- <div id="news">
    <div v-for="n in news" :key="n.id" class="group_news">
      <div class="news_date">
        <span>{{ n.created.day }}</span
        ><br />{{ n.created.month }}<br />{{ n.created.year }}
      </div>
      <div class="ui segment">
        <div class="news_title">
          {{ n.title }}
        </div>
        <p class="news_texte" v-html="n.text"></p>
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  name: "news",
  data: function () {
    return {
      news: [],
    };
  },
  created() {
    this.axios.get("/data/news").then((r) => {
      this.news = r.data;
      this.$store.state.mainInfo.messagesIsSeen = true;
    });
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&family=Montserrat:ital,wght@1,300&family=Mukta:wght@400;500&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500&display=swap");

#news {
  width: 848px;
  margin: auto;
  padding: 100px 20px 20px 80px;
}
.group-notif {
  background-color: white;
  display: flex;
  box-shadow: 0 0 4px 0px #ccc;
  border-radius: 4px;
  margin-bottom: 20px;
}
.date {
  width: 20%;
  border-right: 0.5px solid #3f4d61;
  padding: 15px;
  color: #2f3d4e;
  text-align: center;
  font-family: "Mukta", sans-serif;
  font-style: italic;
  font-size: 1.1em;
}
.contenu {
  width: 80%;
  padding-left: 20px;
  padding-right: 20px;
}
.libelle {
  font-family: "Mukta", sans-serif;
  color: #2f3d4e;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 20px;
}
.texte {
  font-family: "Montserrat", sans-serif;
}

</style>
